// Helper para invalidar el cache del catálogo cuando cambia el stock:
// publicar carta nueva, editar publicación, eliminarla, cambiar estado, etc.
//
// El catálogo (Catalog.jsx) mantiene 2 caches para performance:
//  1. `sessionStorage` con prefijo `hittcg:catalog:v2:` (sobrevive F5).
//  2. `_CATALOG_STATE_CACHE` en memoria (module-level, no exportado).
//
// Sin este helper, cuando el vendedor publicaba/editaba una carta y volvía
// al catálogo EN LA MISMA TAB, el componente restauraba el cache viejo y
// no aparecía el cambio hasta cerrar y reabrir la pestaña (feb 2026 bug).
//
// Uso:
//   import { invalidateCatalogCache } from "@/lib/catalogCache";
//   await api.post("/publications", ...);
//   invalidateCatalogCache();

export function invalidateCatalogCache() {
  // 1. Borrar sessionStorage — cubre F5 y navegación entre pestañas.
  try {
    const toDelete = [];
    for (let i = 0; i < sessionStorage.length; i++) {
      const k = sessionStorage.key(i);
      if (k && k.startsWith("hittcg:catalog:")) toDelete.push(k);
    }
    toDelete.forEach((k) => sessionStorage.removeItem(k));
  } catch { /* sessionStorage puede fallar en modo privado */ }
  // 2. Notificar al Catalog.jsx montado (si lo hay) para que limpie el
  //    cache en memoria y refresque. El listener vive en Catalog.jsx.
  try {
    window.dispatchEvent(new CustomEvent("hittcg:catalog:invalidate"));
  } catch { /* noop */ }
}
